import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";

export class Game extends Phaser.Game {

    public static currentInstance: Phaser.Game;

    constructor(config: Phaser.Types.Core.GameConfig, reactClass?: any) {
        
        super(config);

        GameVars.reactClass = reactClass;
      
        Game.currentInstance = this;
    }

    public onBlur(): void {

        AudioManager.mute();

        super.onBlur();
    }

    public onFocus(): void {

        AudioManager.unmute();

        super.onFocus();
    }
}
